module.exports = __webpack_public_path__ + "img/icon_beneficiary_hover.2c76957b.png";